/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ParentChildMemoControllerDeleteMemoByParent$Params {
  memoId: string;
}

export function parentChildMemoControllerDeleteMemoByParent(http: HttpClient, rootUrl: string, params: ParentChildMemoControllerDeleteMemoByParent$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, parentChildMemoControllerDeleteMemoByParent.PATH, 'delete');
  if (params) {
    rb.path('memoId', params.memoId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

parentChildMemoControllerDeleteMemoByParent.PATH = '/api/child-memo/parent/{memoId}';
